"use strict";

var _regeneratorRuntime = require("/Volumes/Orson/MHub/Projects/go/src/github.com/TheRedBricks/mhub-apps-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileMatchMaxSize = fileMatchMaxSize;
exports.fileMatchMinSize = fileMatchMinSize;
exports.fileMatchSize = fileMatchSize;
exports.fileAccepted = fileAccepted;
exports.readableBytes = readableBytes;
exports.urlToFile = urlToFile;
exports.dataURLtoFile = dataURLtoFile;
exports.blobToFile = blobToFile;
exports.getFileExtensionFromString = getFileExtensionFromString;
exports.getFileName = getFileName;

var _attrAccept = _interopRequireDefault(require("attr-accept"));

var _types = require("./types");

var _math = require("./math");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function fileMatchMaxSize(file, maxSize) {
  var size = file.size;
  return (0, _math.valueMatchMax)(size, maxSize);
}

function fileMatchMinSize(file) {
  var minSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var size = file.size;
  return (0, _math.valueMatchMin)(size, minSize);
}

function fileMatchSize(file, maxSize) {
  var minSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return fileMatchMaxSize(file, maxSize) && fileMatchMinSize(file, minSize);
} // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted


function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || (0, _attrAccept["default"])(file, accept);
}

function readableBytes(bytes) {
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  if (bytes === 0) return 'n/a';
  var i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i === 0) return "".concat(bytes, " ").concat(sizes[i]);
  return "".concat((bytes / Math.pow(1024, i)).toFixed(2) * 1, " ").concat(sizes[i]);
}

function urlToFile(_x, _x2, _x3) {
  return _urlToFile.apply(this, arguments);
}

function _urlToFile() {
  _urlToFile = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, filename, mimeType) {
    var _ref, arrayBuffer, buffer;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!url) {
              _context.next = 9;
              break;
            }

            _context.next = 3;
            return fetch(url);

          case 3:
            _ref = _context.sent;
            arrayBuffer = _ref.arrayBuffer;
            _context.next = 7;
            return arrayBuffer();

          case 7:
            buffer = _context.sent;
            return _context.abrupt("return", new File([buffer], filename, {
              type: mimeType
            }));

          case 9:
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _urlToFile.apply(this, arguments);
}

function dataURLtoFile(dataURL, filename) {
  if (dataURL) {
    var arr = dataURL.split(',');

    if ((0, _types.arrayHasItems)(arr)) {
      var mimeType = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var u8arr = new Uint8Array(bstr.length);

      for (var n = 0; n < u8arr.length - 1; n += 1) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mimeType
      });
    }
  }

  return null;
}

function blobToFile(blob, filename) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'image/jpeg';
  return new File([blob], filename, {
    type: type
  });
}

function getFileExtensionFromString(string) {
  if (string && string.includes('.')) {
    return string.split('.').pop();
  }

  return string;
}

function getFileName(string) {
  if (string && string.includes('.')) {
    return string.split('.')[0];
  }

  return string;
}